export const FLOATING_TOOLTIP_DISMISS_PARAMS = {
  ancestorScroll: true,
  capture: { escapeKey: true },
  referencePress: true,
}

export const FLOATING_TOOLTIP_DELAY_CONFIG = {
  close: 0,
  open: 500,
}
